import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { withFormik } from 'formik'
import type { FormikProps } from 'formik'

import WaitAnimation from '../Common/Wait'
import * as Yup from 'yup'
import { ApiResult, LoadingStatus } from '../../models/Enums'
import { Inventory } from '../../models/Inventory'
import { User } from '../../models/User'
import { axiosPost } from '../Common/Axios'
import { RootState, useAppDispatch, useAppSelector } from '../../store'
import { Result } from '../../models/Dto/Result'
import { UtcToLocalDateString } from '../Common/Util'
import {
  InventoryReply,
  InventoryReplyWriteUser,
} from '../../models/InventoryReply'
import InventoryListItem from '../Common/InventoryListItem'
import { toast } from 'react-hot-toast'
import { BlueButton, OrangeButton } from '../Layout/CommonStyle'
import CloseIcon from '@mui/icons-material/Close'
import { updateInventoryReplyCnt } from '../../store/mainSlice'

interface MyFormProps {
  inventory: Inventory
  inventories: Inventory[]
  //setInventories: (inventories: Inventory[]) => void
  user: User
  onSubmitReply: (values: InventoryReplyFormValues) => void
}

export interface InventoryReplyFormValues {
  inventory: Inventory
  inventories: Inventory[]
  //setInventories: (inventories: Inventory[]) => void
  user: User
  reply: InventoryReply
}

const InnerForm = (props: FormikProps<InventoryReplyFormValues>) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = props

  const [replies, setReplies] = useState<InventoryReplyWriteUser[]>([])
  const [payMin, setPayMin] = useState(0)
  const [payMax, setPayMax] = useState(0)
  const [pointMax, setPointMax] = useState(0)
  const [likeMax, setLikeMax] = useState(0)
  const [recommendMax, setRecommendMax] = useState(0)
  const [memo, setMemo] = useState<string>('')
  const [isLike, setIsLike] = useState<boolean>(false)

  const me = useAppSelector((state: RootState) => state.user.me)
  const dispatch = useAppDispatch()

  const [replyInsertStatus, setReplyInsertStatus] = useState<number>(
    LoadingStatus.NONE
  )

  const handleReplyInsert = async () => {
    if (memo === undefined || memo === '') {
      toast.error('댓글을 입력하세요')
      return
    }
    const payload = {
      inventoryId: values.inventory.id.toString(),
      userId: values.inventory.userId.toString(),
      writeUserId: me.id.toString(),
      content: memo,
    }

    try {
      const result: Result = await axiosPost(
        '/api/inventory/insert_reply',
        payload
      )

      // 여기서 insert_reply의 결과로 reply를 받아서 values.inventory.replies에 추가한다
      if (result.apiResult === ApiResult.SUCCESS) {
        toast.success('댓글이 등록되었습니다')
        setMemo('')

        const inventoryReplyWriteUser = result.data
          .inventoryReplyWriteUser as InventoryReplyWriteUser

        // 댓글 UI에 추가
        values.inventory.replies.unshift(inventoryReplyWriteUser)

        // 댓글 갯수 Update
        values.inventory.replyCnt = result.data.replyCnt as number

        // [inventory change]
        dispatch(
          updateInventoryReplyCnt({
            inventoryId: values.inventory.id,
            replyCnt: values.inventory.replyCnt,
          })
        )

        // values.setInventories(
        //   values.inventories.map((inventory) =>
        //     inventory.id === values.inventory.id ? values.inventory : inventory
        //   )
        // )
      }
    } catch (error) {}
  }

  const handleChangeMemo = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMemo(e.target.value)
  }

  useEffect(() => {
    async function getInventoryReply() {
      const payload = { inventoryId: values.inventory.id }

      const data = await axiosPost('/api/inventory/get_replies', payload)

      console.log(
        '==============================================================='
      )
      console.log('inventoryReplyForm', data)

      //values.inventory.replies = data as InventoryReplyWriteUser[]
      values.inventory = {
        ...values.inventory,
        replies: data as InventoryReplyWriteUser[],
      } as Inventory

      setReplies(values.inventory.replies as InventoryReplyWriteUser[])
    }

    async function getInventoryLike() {
      const payload = {
        likeUserId: me.id,
        jobUserId: values.inventory.userId,
        jobId: values.inventory.job.id,
      }
      try {
        const result = await axiosPost(
          '/api/inventory/get_inventory_like',
          payload
        )
        if (result.apiResult === ApiResult.SUCCESS) {
          setIsLike(result.data === 1)
        }
      } catch (error) {
        console.log('getInventoryLike error', error)
      }
    }

    setReplies([])
    getInventoryReply()
    getInventoryLike()

    if (values.inventories.length > 0) {
      const minLower: number[] = values.inventories.map(
        (inventory: Inventory) => inventory.job.payLower
      )
      const minUpper: number[] = values.inventories.map(
        (inventory: Inventory) => inventory.job.payUpper
      )
      const maxPoint: number[] = values.inventories.map(
        (inventory: Inventory) => inventory.point
      )
      const maxLike: number[] = values.inventories.map(
        (inventory: Inventory) => inventory.likeCnt
        //inventory.replies.reduce((acc, reply) => acc + reply.like, 0)
      )
      const maxRecommend: number[] = values.inventories.map(
        (inventory: Inventory) => inventory.recommendCnt
      )

      setPayMin(Math.min(...minLower))
      setPayMax(Math.max(...minUpper))
      const pm = Math.max(...maxPoint)
      setPointMax(pm === 0 ? 1 : pm)
      const lm = Math.max(...maxLike)
      setLikeMax(lm === 0 ? 1 : lm)
      const rm = Math.max(...maxRecommend)
      setRecommendMax(rm === 0 ? 1 : rm)
    }
  }, [])

  const handleDeleteReply = async (reply: InventoryReplyWriteUser) => {
    if (!confirm('댓글을 삭제하시겠습니까?')) {
      return
    }

    const payload = { replyId: reply.id, inventoryId: reply.inventoryId }
    const result = await axiosPost('/api/inventory/delete_reply', payload)

    if (result.apiResult === ApiResult.SUCCESS) {
      setReplies(replies.filter((r) => r.id !== reply.id))

      // [inventory change]
      values.inventory.replyCnt = result.data as number
      dispatch(
        updateInventoryReplyCnt({
          inventoryId: values.inventory.id,
          replyCnt: result.data as number,
        })
      )

      // values.inventory.replyCnt = result.data as number
      // values.setInventories(
      //   values.inventories.map((inventory) =>
      //     inventory.id === values.inventory.id ? values.inventory : inventory
      //   )
      // )
    }
  }

  return (
    <Container>
      <FormTitle>
        <h2>{values.user.username}</h2>
        <div>님이 선택한 직업</div>
      </FormTitle>
      <InventoryListItem
        inventory={values.inventory}
        inventories={values.inventories}
        //setInventories={values.setInventories}
        payMin={payMin}
        payMax={payMax}
        pointMax={pointMax}
        likeMax={likeMax}
        recommendMax={recommendMax}
        setIsLike={setIsLike}
        isLike={isLike}
        user={me}
        isShowMemo={false}
      />
      <ReplyTitle>친구들 의견</ReplyTitle>
      <Reply>
        {replies.length === 0 && <div>댓글이 없습니다</div>}

        {replies.map((reply, index) => (
          <div key={index}>
            {'writeUser' in reply && (
              <Content>
                <div>
                  <div>{reply.writeUser.username}</div>
                  <div>{UtcToLocalDateString(reply.createTime)}</div>
                </div>
                <div>{reply.content}</div>
                {reply.writeUser.id === me.id && (
                  <DeleteReply onClick={() => handleDeleteReply(reply)}>
                    <CloseIcon />
                  </DeleteReply>
                )}
              </Content>
            )}
          </div>
        ))}
      </Reply>
      <form onSubmit={handleSubmit}>
        <textarea
          name="content"
          placeholder="댓글을 입력하세요"
          onChange={handleChangeMemo}
          //onBlur={handleBlur}
          value={memo}
        />
        {touched.reply?.content && errors.reply?.content ? (
          <ErrorMessage>{errors.reply.content}</ErrorMessage>
        ) : null}

        <OrangeButton
          type="submit"
          disabled={
            isSubmitting || !!(errors.reply?.content && touched.reply?.content)
          }
          onClick={() => handleReplyInsert()}
        >
          {replyInsertStatus == LoadingStatus.PENDING && (
            <WaitAnimation left="100px" top="4px" />
          )}
          댓글 등록
        </OrangeButton>

        {replyInsertStatus === LoadingStatus.REJECTED && (
          <ErrorMessage>오류가 발생했습니다.</ErrorMessage>
        )}
      </form>
    </Container>
  )
}

const InventoryReplyForm = withFormik<MyFormProps, InventoryReplyFormValues>({
  mapPropsToValues: (props) => ({
    inventory: props.inventory,
    inventories: props.inventories,
    //setInventories: props.setInventories,
    user: props.user,
    reply: {
      id: 0,
      inventoryId: props.inventory.id,
      userId: props.inventory.userId,
      writeUserId: 0,
      content: '',
    } as InventoryReply,
  }),

  validationSchema: Yup.object().shape({
    content: Yup.string().required('댓글 내용을 입력하세요'),
  }),

  handleSubmit(
    values: InventoryReplyFormValues,
    { props, setSubmitting, setErrors, submitForm }
  ) {
    props.onSubmitReply(values)
    setSubmitting(false)
  },
})(InnerForm)

const Container = styled.div`
  //width: 100vh;
  @media (max-width: 768px) {
    width: calc(80vw);
    max-height: 80vh;
  }

  max-height: 85vh;
  h1 {
    margin-bottom: 20px;
    font-size: 1.5rem;
    text-align: center;
  }

  input {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    margin-bottom: 5px;
    border: 1px solid #ccc;
  }

  & > form {
    position: relative;
    padding-bottom: 68px;

    & > button {
      width: 200px;
      height: 35px;
      padding: 8px;
      margin-top: 0px;
      margin-bottom: 20px;
      border: none;
      background-color: orange;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }

  textarea {
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    margin-top: 10px;
    padding: 5px;
    border: 1px solid #ccc;
  }
`

const FormTitle = styled.div`
  display: flex;
  font-size: 1.2rem;
`

const ErrorMessage = styled.div`
  color: #5c5cff;
  font-size: 0.9rem;
  padding-bottom: 10px;
`

const ReplyTitle = styled.div`
  padding-top: 20px;
  padding-bottom: 5px;
  font-size: 1.1rem;
  color: #555;
  font-weight: 600;
`
const Reply = styled.div`
  padding: 10px 0;
  //border-top: 1px solid #ccc;
`

const Content = styled.div`
  position: relative;
  padding: 5px 0;
  & > div:nth-child(1) {
    display: flex;
    justify-content: flex-start;
    column-gap: 1rem;
    color: #888;
    padding-bottom: 5px;
  }

  & > div:nth-child(2) {
    padding-bottom: 10px;
    border-bottom: 1px solid #f1f1f1;
  }
  & > div:nth-child(3) {
    position: absolute;
    right: 0;
    top: 0;
  }
`

const DeleteReply = styled.div`
  color: #888;
  cursor: pointer;
  & > svg {
    font-size: 0.9rem;
  }
`

export default InventoryReplyForm
